import axios from 'axios';

/**
 * Provides simple API for making AJAX call
 * Based on Axios.js HTTP transport library
 *
 * @param {String} url
 * @param {String} [method] - HTTP method enum - [get, post, put, patch, delete, options]
 * @param {Object} [headers]
 * @param {Object} [body] - actual for 'post', 'put' and 'patch' methods only
 * @param {String} [responseType] - indicates the type of data that the server will respond with
 * @returns {Promise}
 */
export const request = (url, { method = 'get', headers, body, responseType = 'json', params } = {}) => {
  // TODO: extend it with additional params if it's going to be needed
  const correctedMethod = method.toLowerCase();

  if (!['get', 'post', 'put', 'patch', 'delete', 'options'].includes(correctedMethod)) {
    throw new Error(`request: Invalid HTTP method has been supplied: ${correctedMethod}`);
  }

  let args = [];
  const additionalParameters = { headers, responseType, params };

  // In case of 'post', 'put' and 'patch' methods we need to pass request `body` param as 2nd argument
  if (['post', 'put', 'patch'].includes(correctedMethod)) {
    args = args.concat([url, body, additionalParameters]);
  } else {
    args = args.concat([url, additionalParameters]);
  }

  return axios[correctedMethod](...args);
};

export default request;
